import { fetchWithToken, postWithToken } from "../authentication/AuthProvider";
import config from "../config";

const BASE_URL = `${config.apiUrl}/evidence`;

export const EvidenceAnalysis = {
  /**
   * Analyzes a batch of uploaded utility bills for a scope.
   * @param {FormData} formData Contains 'files', 'scope', 'rowID', etc.
   * @returns {Promise<Response>}
   */
  analyzeBillsBatch: (formData) => {
    return fetchWithToken(`${BASE_URL}/analyze-bills-batch`, {
      method: "POST",
      body: formData,
    });
  },

  /**
   * Commits reviewed and verified bill emission records into the inventory.
   * @param {Object} payload { scope, bills, rowID, IDColumnName, emission_factor, factor_unit }
   * @returns {Promise<Response>}
   */
  saveBatchEmissions: (payload) => {
    return postWithToken(`${BASE_URL}/save-batch-emissions`, payload);
  },

  /**
   * Auto-derives Scope 3 Category 3 emissions from existing Scope 1 & Scope 2 inventory.
   * @param {Object} payload { rowID, IDColumnName }
   * @returns {Promise<Response>}
   */
  autoDeriveCategory3: (payload) => {
    return postWithToken(`${BASE_URL}/auto-derive-category-3`, payload);
  },
};
